module.exports = __webpack_public_path__ + "img/waiting-light.ac71e31b.svg";